import { jsx as i } from "react/jsx-runtime";
import l from "clsx";
import e from "./Skeleton.module.css.js";
const s = ({
  children: a,
  animated: o = !1,
  description: t,
  className: m,
  style: r
}) => /* @__PURE__ */ i(
  "div",
  {
    "aria-label": t,
    className: l(e.container, { [e.animated]: o }, m),
    style: r,
    children: a
  }
);
s.displayName = "Skeleton";
export {
  s as Skeleton
};
//# sourceMappingURL=Skeleton.js.map
